import axios from 'axios';

import { APP_EVENTS, appEventEmitter } from '../utils/eventEmitter.js';
import * as utils from '../utils/utils.js';

/**
 * Global axios instance with interceptors for centralized error handling
 * 
 * Features:
 * - Automatic session expiration detection (401/403)
 * - Emits SESSION_EXPIRED event for AuthContext to handle
 * - Includes credentials for cookie-based authentication
 * - Centralized base URL configuration
 */

const apiClient = axios.create({
    baseURL: utils.backendUrl(),
    timeout: 30000,
    withCredentials: true, // Enable cookies for JWT authentication
    headers: {
        'Content-Type': 'application/json',
    },
});

// Request interceptor (for future enhancements like adding tokens)
apiClient.interceptors.request.use(
    (config) => config,
    (error) => Promise.reject(error)
);

// Response interceptor - Handle errors globally
apiClient.interceptors.response.use(
    (response) => response,
    (error) => {
        if (error.response) {
            const { status, data } = error.response;

            // Handle unauthorized or forbidden - session expired
            if (status === 401 || status === 403) {
                // Emit event for AuthContext to handle logout and redirect
                appEventEmitter.emit(APP_EVENTS.SESSION_EXPIRED, {
                    status,
                    message: data?.message || 'Session expired',
                });
            }
        }

        return Promise.reject(error);
    }
);

export default apiClient;

